import { Box } from "@mui/material";
import map from "../lep_map.webp";

export const WinterStorage = () => {
  return (
    <div className="page">
      Need somewhere to keep your trailer in the offseason? You can leave it
      with us for the winter for $300. Send us an email (mail@landsendpark.com)
      or give us a call (519-596-2523) to talk about details and to give us an
      approximate date for when you'll be dropping it off.
    </div>
  );
};
